import { SET_SIDEBAR_OPTIONS, SET_PERMISSIONS } from './actions';

const initialState = {
  sidebarOptions: [],
  permissions: {},
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIDEBAR_OPTIONS:
      return {
        ...state,
        sidebarOptions: action.payload,
      };
      case SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    default:
      return state;
  }
}

export default sidebarReducer;